import { createFileRoute } from '@tanstack/react-router'

export interface IntegrationBooksSearch {
  q?: string
  client?: string
  platform?: string
  status?: 'connected' | 'attention' | 'not-connected'
  country?: string
  page?: number
}

export const Route = createFileRoute('/integrations/books')({
  validateSearch: (
    search: Record<string, unknown>,
  ): IntegrationBooksSearch => ({
    q:
      typeof search.q === 'string' && search.q.trim()
        ? search.q.trim()
        : undefined,
    client:
      typeof search.client === 'string' && search.client
        ? search.client
        : undefined,
    platform:
      typeof search.platform === 'string' && search.platform
        ? search.platform
        : undefined,
    status:
      search.status === 'connected' ||
      search.status === 'attention' ||
      search.status === 'not-connected'
        ? search.status
        : undefined,
    country:
      typeof search.country === 'string' && search.country
        ? search.country
        : undefined,
    page:
      typeof search.page === 'number' && search.page > 1
        ? Math.floor(search.page)
        : undefined,
  }),
})
